var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.className]},[_c('a-tabs',{attrs:{"type":_vm.type,"activeKey":_vm.activeKey},on:{"change":(key) => _vm.$emit('change', key)}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }